import { MDExternalLinks } from "../../components/results-grid/grid-row/ExternalLinks";
import { VizChip } from "../../components/canvas/VizChip";

export const getOverrides = () => {
  return {
    Links: { component: MDExternalLinks },
    VizChip: { component: VizChip },
  };
};

export const overrideMapSample = getOverrides();
